module.exports = "<h1 mat-dialog-title>Confirmación</h1>\r\n<div mat-dialog-content>\r\n  <p>¿Está seguro de eliminar este registro?</p>\r\n</div>\r\n<div mat-dialog-actions>\r\n  <button mat-button (click)=\"onNoClick()\">Cancelar</button>\r\n  <button mat-button (click)=\"eliminar()\" cdkFocusInitial>Eliminar</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/REPO/FacturacionWeb/src/app/main/content/Dialog/ConfirmarEliminacion.component.html
// module id = ../../../../../src/app/main/content/Dialog/ConfirmarEliminacion.component.html
// module chunks = main